import { getSafe } from 'src/app/shared/util/get-safe';
import { InvoicePaymentDto } from 'src/app/revenue/shared/invoice-payment/dto/invoice-payment.dto';
import { InvoiceService } from '../../shared/invoice/invoice.service';
import { InvoiceDto } from '../../../invoices/dto/invoice.dto';
import { TranslationService } from 'src/app/shared';
import { Component, OnInit, Input } from '@angular/core';
import { InvoiceAdvancedSearchResult } from '../../shared/invoice/invoice-advanced-search-result.model';

@Component({
  selector: 'wl-expandable-transaction-description',
  templateUrl: './expandable-transaction-description.component.html',
  styleUrls: ['./expandable-transaction-description.component.less'],
    standalone: false
})
export class ExpandableTransactionDescriptionComponent implements OnInit {
  @Input() invoiceResult: InvoiceAdvancedSearchResult = {} as InvoiceAdvancedSearchResult;
  public invoiceWithPayments: InvoiceDto;
  public invoicePayments: InvoicePaymentDto[];
  public otherLineItemMapping: { [k: string]: string };
  public expanded = false;
  public loading: boolean;
  public buttonText: string;

  constructor(private _translationService: TranslationService, private _invoiceService: InvoiceService) {}

  ngOnInit() {
    this.buttonText = this._translationService.getInstant('revenue.transactions-grid.expandable-description.expand');
    this.otherLineItemMapping = {
      '=1': this._translationService.getInstant('revenue.transactions-grid.expandable-description.other-line-item'),
      other: this._translationService.getInstant('revenue.transactions-grid.expandable-description.other-line-items'),
    };
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.buttonText = this._translationService.getInstant('revenue.transactions-grid.expandable-description.collapse');
    } else {
      this.buttonText = this._translationService.getInstant('revenue.transactions-grid.expandable-description.expand');
    }
    if (!this.invoiceWithPayments) {
      this.loading = true;
      this._invoiceService.getInvoiceAndInvoicePayments(this.invoiceResult.InvoiceNum).then(
        (invoice) => {
          this.invoiceWithPayments = invoice;
          this.fillInvoicePaymentsArray();
          this.loading = false;
        },
        () => (this.loading = false)
      );
    }
  }

  private fillInvoicePaymentsArray() {
    this.invoicePayments = [];
    if (getSafe(() => this.invoiceWithPayments.InvoiceLineItems)) {
      this.invoiceWithPayments.InvoiceLineItems.forEach((lineItem) => {
        if (lineItem.InvoicePayments) {
          this.invoicePayments.push(...lineItem.InvoicePayments);
        }
      });
    }
  }
}
